(ns app.front.view.pdf-markup.stamp-picker
  (:require [app.domain.stamp.model :as stamp-model]
            [app.front.ui :as ui]
            [app.front.ui.anchored-popup :as anchored-popup]
            [app.front.ui.select :as ui-select]
            [app.front.view.pdf-markup.embedpdf :as epdf]
            [app.front.view.pdf-markup.stamp-subs :as stamp-subs]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]))

(defn picker
  "PDF stamp picker. Render with :f> to use the current document's annotation hook."
  [{:keys [tr anchor]}]
  (let [^js annotation                                    (epdf/useAnnotation)
        {:keys [picker busy?]}                            (<sub [::stamp-subs/state])
        {:keys [context selected-id date loading? error]} picker
        stamp                                             (some (fn [stamp]
                                                                  (when (= selected-id (:id stamp))
                                                                    stamp))
                                                                (:stamps context))
        date?                                             (stamp-model/has-type? (:layout stamp) :date)
        valid?                                            (and stamp (stamp-model/valid-layout? (:layout stamp)))]
    (when picker
      [anchored-popup/popup
       {:id         "pdf-stamp-picker"
        :anchor     anchor
        :aria-label (tr [:stamp/select])
        :style      {:width "336px"}
        :on-close   #(>evt [::stamp-subs/close])}
       [:div.p-4.bg-white.space-y-3 {:aria-label (tr [:stamp/select])}
        (cond
          loading?
          [:p {:role "status"} (tr [:loading])]

          (seq (:stamps context))
          [:<>
           [ui-select/select
            {:id           "stamp-selection"
             :allow-empty? false
             :label-text   (tr [:stamp/select])
             :values       (mapv :id (:stamps context))
             :value        selected-id
             :on-change    #(rf/dispatch-sync [::stamp-subs/select %])
             :val->str     (fn [id]
                             (some (fn [stamp]
                                     (when (= id (:id stamp))
                                       (:name stamp)))
                                   (:stamps context)))}]
           (when date?
             [ui/date-picker
              {:tr         tr
               :id         "stamp-date"
               :width      "100%"
               :label-text (tr [:stamp/date])
               :value      (some-> date date-util/parse-local-date)
               :callback   #(rf/dispatch-sync
                              [::stamp-subs/date (some->> % (.format date-util/calendar-date-format))])}])
           (when-not valid?
             [:p {:role "alert"}
              (tr [:stamp/invalid-definition])])]

          (not error)
          [:p (tr [:stamp/empty])])
        (when error
          [:p {:role "alert"}
           (tr [error])])
        [:div.flex.gap-3
         (when (seq (:stamps context))
           [ui/button {:disabled (boolean (or busy? (not valid?) (and date? (nil? date))))
                       :on-click #(rf/dispatch-sync [::stamp-subs/apply annotation])}
            (tr [:stamp/use])])
         [ui/button
          {:kind     :secondary
           :disabled (boolean busy?)
           :on-click #(>evt [::stamp-subs/close])}
          (tr [:cancel])]]]])))
